import {featureDiagrams} from '../../content/featureDiagrams.js';
import {featureScenes} from '../../content/featureScenes.js';
import {FeatureSceneCard} from '../FeatureSceneCard/FeatureSceneCard.js';
import {MemoryDiagram} from '../MemoryDiagram/MemoryDiagram.js';

import type {ReactElement} from 'react';

const layouts: Readonly<Record<string, string>> = {
  characters: 'dossier',
  credits: 'access',
  elements: 'collection',
  gemini: 'workspace',
  projects: 'workspace',
  'quick-video': 'comparison',
  seedance: 'comparison',
  storyboards: 'timeline',
  style: 'moodboard',
  takes: 'collection'
};

const selections: Readonly<Record<string, readonly number[]>> = {
  access: [1, 2],
  comparison: [0, 2],
  dossier: [1, 2]
};
const headings: Readonly<Record<string, string>> = {
  access: 'YOUR WORKSPACE',
  collection: 'CREATIVE SELECTION',
  comparison: 'REFERENCE / RESULT',
  dossier: 'CHARACTER DOSSIER',
  timeline: 'SHOT SEQUENCE'
};

export const FeatureDiagram = ({featureId}: {readonly featureId: string}): ReactElement | null => {
  const diagram = featureDiagrams[featureId];
  const scenes = featureScenes[featureId];
  if(!diagram || !scenes) {
    return null;
  }
  const layout = layouts[featureId] || 'workspace';
  const indices = selections[layout] || [0, 1, 2];
  return <figure aria-label="Feature workflow" className="feature-scene my-5 overflow-hidden rounded-2xl border border-violet-300/15" data-layout={featureId === 'memory' ? 'memory' : layout}>
    {featureId === 'memory' ? <MemoryDiagram /> : <div className={`feature-board feature-board-${layout}`}>
      <div className="feature-board-heading"><span>{headings[layout] || 'CREATIVE WORKSPACE'}</span><span>REACTORBOX</span></div>
      <ol className="feature-board-items">
        {indices.map((sceneIndex) => {
          const scene = scenes[sceneIndex]!;
          const {description, icon: Icon, label} = diagram.steps[sceneIndex]!;
          return <li className="feature-board-item" key={label}>
            <div className="feature-board-media"><FeatureSceneCard scene={scene} /></div>
            <div className="feature-board-label"><Icon aria-hidden="true" size={16} /><div><p>{label}</p><span>{description}</span></div></div>
          </li>;
        })}
      </ol>
      {layout === 'comparison' && <div className="feature-direction"><span>DIRECTION</span><p>{scenes[1]?.lines?.join(' · ')}</p></div>}
      {layout === 'timeline' && <div aria-hidden="true" className="feature-edit-track"><span>ESTABLISH</span><span>DEVELOP</span><span>REVEAL</span></div>}
      {layout === 'access' && <p className="feature-access-note">Start with free planning. Generation and media storage require a paid membership.</p>}
    </div>}
    <figcaption className="relative border-t border-white/10 px-5 py-3 text-xs leading-5 text-zinc-200">{diagram.caption}<span className="mt-1 block text-[10px] text-zinc-300">Illustrative concept · Not a live generation or character simulation</span></figcaption>
  </figure>;
};
